export default function AboutSection() {
  const stats = [
    { value: "2021", label: "Год основания" },
    { value: "800+", label: "Операторов в штате" },
    { value: "380₽", label: "Ставка в час" },
    { value: "99%", label: "Выплат без задержек" },
  ];

  const team = [
    {
      name: "Алексей Морозов",
      role: "Основатель & CEO",
      img: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20confident%20russian%20male%20business%20executive%20in%20his%2035s%2C%20dark%20navy%20suit%2C%20clean%20minimal%20light%20blue%20gradient%20background%2C%20studio%20lighting%2C%20sharp%20focus%2C%20corporate%20headshot%20photography%2C%20high%20quality&width=300&height=300&seq=ws-team1&orientation=squarish",
    },
    {
      name: "Екатерина Дмитриева",
      role: "HR",
      img: "/team/ekaterina-dmitrieva.jpg",
    },
  ];

  const tags = ["Прямой работодатель", "Оплачиваемое обучение", "Карьерный рост", "Официальное оформление"];

  return (
    <section id="about" className="relative py-24 lg:py-32 overflow-hidden bg-background-100">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold tracking-widest uppercase mb-4 bg-primary-100 text-primary-700">
            О компании
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground-950 mb-5">
            WorkTerra —{" "}
            <span className="text-primary-500">ваш прямой работодатель</span>
          </h2>
          <p className="text-foreground-600 text-base lg:text-lg max-w-2xl mx-auto leading-relaxed">
            Мы не кадровое агентство и не посредники. Мы напрямую нанимаем операторов чата в штат, проводим оплачиваемое обучение и платим стабильно 380₽/час. Никаких скрытых комиссий и вычетов.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-16">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-2xl p-6 text-center bg-background-50 border border-primary-100 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="text-3xl lg:text-4xl font-extrabold mb-2 text-primary-500">
                {stat.value}
              </div>
              <div className="text-foreground-600 text-sm lg:text-base">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16 items-center">
          <div>
            <h3 className="text-2xl lg:text-3xl font-bold text-foreground-950 mb-5">
              Почему выбирают нас
            </h3>
            <p className="text-foreground-600 leading-relaxed mb-4 text-sm lg:text-base">
              WorkTerra основана в 2021 году с простой идеей: дать людям возможность зарабатывать стабильно, работая из дома. Мы нанимаем операторов чата напрямую — вы оформляетесь к нам в штат, а не к сторонним заказчикам.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-6 text-sm lg:text-base">
              Сегодня в нашей команде более 800 операторов. Мы обеспечиваем полный цикл: оплачиваемое обучение с нуля, стажировку и выход на стабильный график с зарплатой 380₽/час. Выплаты дважды в месяц — без задержек.
            </p>
            <div className="flex flex-wrap gap-3">
              {tags.map((tag) => (
                <span
                  key={tag}
                  className="px-4 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-900"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-lg border border-primary-100">
            <img
              alt="Команда WorkTerra"
              className="w-full h-64 lg:h-80 object-cover object-top"
              src="https://readdy.ai/api/search-image?query=modern%20bright%20office%20with%20blue%20accents%20team%20of%20chat%20operators%20working%20on%20laptops%2C%20clean%20minimal%20workspace%20with%20soft%20natural%20lighting%20and%20blue%20white%20color%20scheme%2C%20professional%20call%20center%20environment&width=700&height=450&seq=ws-about1&orientation=landscape"
            />
          </div>
        </div>

        <div>
          <h3 className="text-2xl lg:text-3xl font-bold text-foreground-950 text-center mb-10">
            Наша команда
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-xl mx-auto">
            {team.map((member) => (
              <div
                key={member.name}
                className="rounded-2xl p-6 text-center transition-all duration-300 hover:-translate-y-2 bg-background-50 border border-primary-100 shadow-sm hover:shadow-md"
              >
                <div className="w-20 h-20 rounded-full overflow-hidden mx-auto mb-4 border-2 border-primary-200">
                  <img
                    alt={member.name}
                    className="w-full h-full object-cover object-top"
                    src={member.img}
                  />
                </div>
                <h4 className="text-foreground-950 font-semibold text-base mb-1">
                  {member.name}
                </h4>
                <p className="text-primary-500 font-medium text-sm">{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}